'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  var pathToDances = ['one'];

  switch (action.type) {
    case 'GET_DANCES':
      return action.payload.reduce(function (state, dance) {
        return state.deleteIn(pathToDances.concat(['loading'])).mergeIn(pathToDances, (0, _immutable.fromJS)(_defineProperty({}, dance.id, dance)));
      }, state);

    case 'GET_DANCES_START':
      return state.setIn(pathToDances, (0, _immutable.fromJS)({ loading: true }));

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/setMusic/index.js
// module id = 709
// module chunks = 0